import { PlatformCMSUrl } from "../common";
import { PageBlockComponent } from "./widgetCmsData";

export function mapCardResponse(components: PageBlockComponent[]): CardConfig[] {
  const cards = [];

  for (let index = 0; index < components.length; index += 2) {
    cards.push({
      ...components[index],
      mediaUrl: (extractMediaUrl(components[index + 1]?.description!)),
    });
  }

  return cards;
}

function extractMediaUrl(input: string): string {
  if (!input) {
    return '';
  }

  const match = input.match(/\((\/.*?)\)$/);

  return  match ? PlatformCMSUrl() + match[1] : "";
}

export interface CardConfig {
  mediaUrl: string;
  description?: string;
  id?: number;
  title?: string;
}
